import React from 'react';
import './style/CookieBanner.scss';
import LocaleString from 'app/ui/config/LocaleString';
import {
  getBrandItem,
  getString,
} from '../../../api/redux-watson/watson-config-selectors';
import connect from 'app/api/redux-util/connect-enhancer';
import SimpleThemer from 'app/ui/config/SimpleThemer';
import Button from '../../core/common/Button';
import SimpleTextLink from '../../core/common/SimpleTextLink';
import { acceptCookies, cookiesAccepted } from '../../../api/cookies';
import { isTeacherRoute } from '../../../api/redux-route/route-utils';

export const BANNER_HEIGHT = 72;

class CookieBanner extends React.Component {
  state = {
    showing: this.props.enabled && !cookiesAccepted(),
  };

  onAccept = () => {
    acceptCookies();
    this.setState({
      showing: false,
    });
  };

  render() {
    if (!this.state.showing) {
      return null;
    }

    let linkStyles = {
      color: 'common.ErrorPageLink',
    };

    let buttonStyles = {
      backgroundColor: 'common.TextButton.default.base.bg',
      color: 'common.TextButton.default.base.fg',
      hoverBackgroundColor: 'common.TextButton.default.hover.bg',
      hoverColor: 'common.TextButton.default.hover.fg',
    };

    if (isTeacherRoute(this.props.location.pathname)) {
      linkStyles = {
        color: 'teacher.textLink',
      };

      buttonStyles = {
        backgroundColor: 'teacher.matchVstuiButton.default',
        hoverBackgroundColor: 'teacher.matchVstuiButton.hover',
      };
    }

    return (
      <div
        className="CookieBanner"
        role="banner"
        style={{ height: BANNER_HEIGHT }}
      >
        <p>
          <LocaleString
            id="common.cookie.info"
            params={{
              policyLink: (
                <SimpleThemer
                  key="link"
                  {...linkStyles}
                  render={c => (
                    <SimpleTextLink className={c} href={this.props.link}>
                      <LocaleString id="common.cookie.cookiePolicy" />
                    </SimpleTextLink>
                  )}
                />
              ),
            }}
          />
        </p>
        <SimpleThemer
          {...buttonStyles}
          render={c => (
            <Button className={c} onClick={this.onAccept}>
              <LocaleString id="common.cookie.acceptAndClose" />
            </Button>
          )}
        />
      </div>
    );
  }
}

export default connect(state => ({
  link: getString(state, 'common.links.cookies'),
  enabled: getBrandItem(state, 'common.cookieBanner.enabled'),
}))(CookieBanner);

export const CookieBannerTest = CookieBanner;
